<template>
  <div v-if="open && !$route.meta.displayMode" class="overlay">
    <div class="modal">
      <h3>Hay una nueva versión</h3>
      <p class="sub">
        Esta página se recargará automáticamente en {{ remaining }}s para aplicar la actualización.
      </p>

      <div class="progress-wrap" aria-label="Actualizando">
        <div class="progress-bar" :style="{ width: percent + '%' }"></div>
      </div>

      <button class="cta" @click="refresh" :disabled="updating">
        {{ updating ? 'Actualizando…' : 'Actualizar ahora' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdatePrompt',
  data() {
    return {
      open: false,
      registration: null,
      percent: 0,
      remaining: 10,
      updating: false,
      P_timer: null
    }
  },
  mounted() {
    window.addEventListener('swUpdated', this.onSwUpdated)
  },
  beforeUnmount() {
    window.removeEventListener('swUpdated', this.onSwUpdated)
    this.clearTimer()
  },
  methods: {
    onSwUpdated(e) {
      this.registration = e.detail
      if (this.$route.meta.displayMode) {
        window.__promoUpdateRegistration = e.detail
        window.dispatchEvent(new CustomEvent('promo-sw-update', { detail: e.detail }))
        return
      }
      this.open = true
      this.startCountdown()
    },
    startCountdown() {
      this.clearTimer()
      const totalMs = 10000
      const stepMs = 100
      let elapsed = 0

      this.percent = 0
      this.remaining = Math.ceil((totalMs - elapsed) / 1000)

      this.P_timer = setInterval(() => {
        elapsed += stepMs
        this.percent = Math.min(100, Math.round((elapsed / totalMs) * 100))
        this.remaining = Math.max(0, Math.ceil((totalMs - elapsed) / 1000))

        if (elapsed >= totalMs) {
          this.clearTimer()
          this.refresh()
        }
      }, stepMs)
    },
    clearTimer() {
      if (this.P_timer) {
        clearInterval(this.P_timer)
        this.P_timer = null
      }
    },
    refresh() {
      if (this.updating) return
      this.updating = true

      // Pide al SW que se active ya
      this.registration?.waiting?.postMessage({ type: 'SKIP_WAITING' })
      // El reload lo hace controllerchange en registerServiceWorker.js
    }
  }
}
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.55);
  display: grid;
  place-items: center;
  z-index: 9999;
}

.modal {
  width: min(92vw, 440px);
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 12px 48px rgba(0,0,0,.25);
  text-align: center;

  h3 {
    margin: 0 0 8px;
    font-weight: 700;
    font-size: 1.125rem;
  }

  .sub {
    margin: 0 0 16px;
    color: #555;
  }

  .progress-wrap {
    width: 100%;
    height: 10px;
    background: #eee;
    border-radius: 999px;
    overflow: hidden;
    margin: 12px 0 20px;
  }

  .progress-bar {
    height: 100%;
    width: 0%;
    background: linear-gradient(90deg, #7c3aed, #a855f7);
    transition: width .1s linear;
  }

  .cta {
    width: 100%;
    padding: 12px 16px;
    border: 0;
    border-radius: 10px;
    background: #7c3aed;
    color: #fff;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
      opacity: .7;
      cursor: default;
    }
  }
}
</style>
